/*
 * ============================================================================
 *  LEGACY (payload_version = 0) ADAPTER — DELETE THIS FILE when no v0 rows remain.
 * ============================================================================
 *
 * v0 rows store payload/updated_payload as FLAT, frontend-shaped objects and have no
 * server-computed payload_difference, so the diff has to be recomputed in the browser.
 *
 * This file is deliberately the ONLY place that v0 knowledge lives. To retire v0:
 *   1. delete this file
 *   2. delete the single `if (!isKeyedPayload(action))` branch in buildComparisonGroups.js
 *   3. delete services/utils.js `compareByKeys` (nothing else uses it)
 * Nothing else in the UI needs to change.
 *
 * NOTE: the compareByKeys it relies on flattens nested objects into one map, so a nested
 * key can shadow a top-level one and hide a real change. That bug is fixed on the server
 * for v1 rows (which use payload_difference instead); it is knowingly left alone here
 * because this code path is scheduled for deletion and only ever sees historical rows.
 */
import { compareByKeys } from "../services/utils";
import { HIDDEN_KEYS } from "./constants";

export const buildLegacyGroups = (action) => {
  const rows = compareByKeys(action?.payload, action?.updated_payload)
    .filter((item) => !HIDDEN_KEYS.includes(item.key))
    .map((item) => ({ field: item.key, before: item.obj1, after: item.obj2 }));

  if (!rows.length) return [];
  return [{ table: action?.ref_table_name, rows }];
};
